import { FC } from "react";

import { Board } from "../../components/organisms";
import { useWindowDimensions } from "../../hooks";

const BoardPage: FC<{}> = () => {
  const { height } = useWindowDimensions();

    return (
        <div className="board" style={{height: height, overflow: "hidden" }}>
          <Board/>
        </div>
    );
};

export default BoardPage;